import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import jaCommon from "./ja/common.json";
import jaAdmin from "./ja/admin.json";
import enCommon from "./en/common.json";
import enAdmin from "./en/admin.json";

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      ja: { common: jaCommon, admin: jaAdmin },
      en: { common: enCommon, admin: enAdmin },
    },
    lng: localStorage.getItem("locale") ?? "ja",
    fallbackLng: "ja",
    ns: ["common", "admin"],
    defaultNS: "admin",
    interpolation: { escapeValue: false },
  });

export default i18n;
